<div id="footer">
  <div class="w-full text-center">
    <p>* Any Gambling conducted through MB Colossus will be based outside the Jurisdiction of Alderney and is not licenced by the AGCC</p>
    <p>* Colossusbets Limited is licensed and regulated by the U.K. <a href="https://secure.gamblingcommission.gov.uk/gccustomweb/PublicRegister/PRSearch.aspx?ExternalAccountId=31514" target="_blank">Gambling Commission</a>, Licence No: 000-031514-R-314905-001</p>
  </div>
</div>
